<ng-template #contentHeaderTemplate></ng-template>

<app-table id="dashboard.time-tracking.employees.index"></app-table>
